<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item href="#collaborativeList" active>Collaborative List</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">Collaborative List</h1>
    <p>Collaborate together to achieve the goals.</p>
    <hr>
    <div>
      <div class="input-container">
        <b-row>
          <b-col class="col-2">
            <label class="input-title">Sort by</label>
          </b-col>
          <b-col>
            <b-form-select v-model="sortTypeSelected" :options="sortTypeOptions" @change="getCollaborativeListData(sortTypeSelected)"></b-form-select>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="list-container">
      <div v-if="showPlaceholderImage && !hideWhenInitialLoad" class="no-collaborative-list-container">
        <b-img class="no-collaborative-list-picture" :src="require('../../assets/no_collaborative_list.png')"
               alt="No collaborative list picture"></b-img>
        <h2>No Collaborative List</h2>
        <p>Your collaborative to-do list will be shown here</p>
      </div>
      <collaborative-list-cell v-else v-for="collaborativeList in collaborativeListDocuments" :key="collaborativeList.toDoListId" :listDetails="collaborativeList"></collaborative-list-cell>
    </div>
    <fab
        position="bottom-right"
        bg-color="#565A7B"
        icon-size="small"
        @click.native="openCreationModal"
    ></fab>
  </div>
</template>

<script>
  import CollaborativeListCell from "../table_cells/list_cells/CollaborativeListCell.vue"
  import {mapActions, mapGetters} from "vuex"
  import {db} from "../../main"
  import fab from 'vue-fab'

  export default {
    data() {
      return {
        showPlaceholderImage: null,
        hideWhenInitialLoad: true,
        collaborativeListDocuments: null,
        sortTypeSelected: 'Creation time (Ascending)',
        sortTypeOptions: [
          {value: 'Creation time (Ascending)', text: 'Creation time (Ascending)'},
          {value: 'Creation time (Descending)', text: 'Creation time (Descending)'},
          {value: 'List name (Ascending)', text: 'List name (Ascending)'},
          {value: 'List name (Descending)', text: 'List name (Descending)'}
        ]
      }
    },
    components: {
      collaborativeListCell: CollaborativeListCell,
      fab
    },
    methods: {
      ...mapActions([
        "updateListCategory"
      ]),
      openCreationModal() {
        this.$store.dispatch('setupCreationModal')
        this.showModal('creation-modal')
      },
      getCollaborativeListData(sortTypeSelected) {
        if (sortTypeSelected === 'Creation time (Ascending)') {
          this.$bind(
            'collaborativeListDocuments',
            db
              .collection('collaborative_to_do_lists')
              .where("toDoListCollaboratorId", 'array-contains', this.$store.getters.user.data.id)
              .orderBy("toDoListCreationTime", 'asc')
          ).then(() => {
            if (this.collaborativeListDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortTypeSelected === 'Creation time (Descending)') {
          this.$bind(
            'collaborativeListDocuments',
            db
              .collection('collaborative_to_do_lists')
              .where("toDoListCollaboratorId", 'array-contains', this.$store.getters.user.data.id)
              .orderBy("toDoListCreationTime", 'desc')
          ).then(() => {
            if (this.collaborativeListDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortTypeSelected === 'List name (Ascending)') {
          this.$bind(
            'collaborativeListDocuments',
            db
              .collection('collaborative_to_do_lists')
              .where("toDoListCollaboratorId", 'array-contains', this.$store.getters.user.data.id)
              .orderBy("toDoListName", 'asc')
          ).then(() => {
            if (this.collaborativeListDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        } else if (sortTypeSelected === 'List name (Descending)') {
          this.$bind(
            'collaborativeListDocuments',
            db
              .collection('collaborative_to_do_lists')
              .where("toDoListCollaboratorId", 'array-contains', this.$store.getters.user.data.id)
              .orderBy("toDoListName", 'desc')
          ).then(() => {
            if (this.collaborativeListDocuments.length === 0) {
              this.showPlaceholderImage = true
            }
            this.hideWhenInitialLoad = false
          })
        }
      },
      showModal(id) {
        this.$root.$emit('bv::show::modal', id)
      }
    },
    watch: {
      collaborativeListDocuments(newProperties, oldProperties) {
        this.showPlaceholderImage = this.collaborativeListDocuments.length === 0
      },
    },
    mounted() {
      this.getCollaborativeListData(this.sortTypeSelected)
    }
  }
</script>

<style scoped>
  .no-collaborative-list-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .no-collaborative-list-picture {
    width: 375px;
    margin-bottom: 1em;
  }

  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .list-container {
    height: 63vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  }

  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    margin-top: 0.5em;
  }
</style>
